import React from 'react'
import { ClickAwayListener, Fade, Menu, MenuItem } from '@mui/material'

import PhoneFlag from '../../../../../atoms/PhoneFlag'
import DownArrowSmallIcon from '../../../../../icons/DownArrowSmallIcon'
import RemoveAgentIcon from '../../../../ChatWindowV2/Header/TransferModal/Icon'
import Tooltip from '../../../../../atoms/Tooltip'

import { getFormatted } from '@SonarCX/utilities/phoneNumber'

import useStyles from '../styles'

const SmsPill = ({
  user,
  channel,
  smsChannels = [],
  handleOnRemoveClick,
  setUsers
}) => {
  const [channelsMenuOpen, setChannelsMenuOpen] = React.useState(false)
  const ref = React.useRef<any>()
  const handleChannelClick = React.useCallback(
    ch => {
      //click same channel of pill case
      if (ch.id === channel.id) {
        return
      }
      setUsers(old => {
        const alreadyExists = old.some(
          entry => entry.user.id === user.id && entry.channel.id === ch.id
        )
        //means its repeated
        if (alreadyExists) {
          //removes current one, leaves the repeated in the list since its the same channel.
          const indexForRemoval = old.findIndex(
            entry =>
              entry.user.id === user.id && entry.channel.id === channel.id
          )
          const copy = [...old]
          const result = copy
            .slice(0, indexForRemoval)
            .concat(copy.slice(indexForRemoval + 1))
          return result
        }
        return old.map(i => {
          if (i.user.id === user.id && i.channel.id === channel.id) {
            i.channel = ch
          }
          return i
        })
      })
    },
    [setUsers, user, channel]
  )

  const classes = useStyles()

  return (
    <>
      <div>
        <div className={classes.pillUserName}>{user?.name}</div>
        <div className={classes.flagHolder} ref={ref}>
          <PhoneFlag value={channel.value} className={classes.flagSize} />
          <span className={classes.smsValue}>
            {getFormatted(channel.value)}
          </span>
        </div>
      </div>
      {smsChannels.length > 1 && (
        <DownArrowSmallIcon
          onClick={() => setChannelsMenuOpen(true)}
          style={{ marginLeft: 6 }}
        />
      )}

      <Tooltip title='Remove from list' arrow>
        <span>
          <RemoveAgentIcon
            onClick={() => {
              handleOnRemoveClick(user, channel)
            }}
          />
        </span>
      </Tooltip>

      {channelsMenuOpen && (
        <ClickAwayListener onClickAway={() => setChannelsMenuOpen(false)}>
          <Menu
            onClose={() => setChannelsMenuOpen(false)}
            open={channelsMenuOpen}
            disableEnforceFocus
            anchorEl={ref.current}
            anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            transformOrigin={{ horizontal: 'center', vertical: 4 }}
            TransitionComponent={Fade}
            classes={{ paper: classes.resultsContainer }}
          >
            <label className={classes.extraChannelsLabel}>
              Select phone number
            </label>
            <div className={classes.extraChannelsResults}>
              {smsChannels.map((channel, index) => {
                return (
                  <MenuItem
                    key={`${channel.id}-sms-pill`}
                    component='div'
                    className={classes.result}
                    onClick={() => {
                      handleChannelClick(channel)
                      setChannelsMenuOpen(false)
                    }}
                    disableGutters
                  >
                    <div>
                      <label className={classes.smsResult}>{user?.name}</label>
                      <PhoneFlag
                        value={channel.value}
                        className={classes.flag}
                      />
                      <label className={classes.smsValue}>
                        {getFormatted(channel.value)}
                      </label>
                    </div>
                  </MenuItem>
                )
              })}
            </div>
          </Menu>
        </ClickAwayListener>
      )}
    </>
  )
}

export default SmsPill
